import { memo, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import DataTable from "react-data-table-component";
import { Tab } from 'react-bootstrap';
import NCICNav from "@/CADComponents/NCICModal/NCICNavBar/NCICNav";
import VINSection from "@/CADComponents/NCICModal/NCICTabSection/VINSection";
import NameSection from "@/CADComponents/NCICModal/NCICTabSection/NameSection";
import { compareStrings, isEmptyCheck } from "@/CADUtils/functions/common";
import { getShowingMonthDateYear, getShowingWithFixedTime, getShowingWithOutTime, tableCustomStyles } from "@/Components/Common/Utility";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useObjState from "@/CADHook/useObjState";
import './index.css';
import ResponseSection from "@/CADComponents/NCICModal/ResponseSection";
import Tooltip from "@/CADComponents/Common/Tooltip";
import WantedSection from "@/CADComponents/NCICModal/NCICTabSection/WantedSection";
import DriverLicenseSection from "@/CADComponents/NCICModal/NCICTabSection/DriverLicenseSection";
import WantedCheckSection from "@/CADComponents/NCICModal/NCICTabSection/WantedCheckSection";
import StolenVehicleSection from "@/CADComponents/NCICModal/NCICTabSection/StolenVehicleSection";
import NcicServices from "@/CADServices/APIs/ncic";
import { useSelector } from "react-redux";
import { fetchPostData, ScreenPermision } from "@/Components/hooks/Api";
import { Comman_changeArrayFormat, Comman_changeArrayFormat3 } from "@/Components/Common/ChangeArrayFormat";
import { useQuery } from "react-query";
import { toastifyError, toastifySuccess } from "@/Components/Common/AlertMsg";
import { getShowingDateText } from "@/Components/Common/Utility";

const NCICModal = (props) => {
    const {
        openNCICModal = false,
        setOpenNCICModal = () => { },
        isNameCallTaker = false,
        setIsNameCallTaker = () => { },
        nameData = {},
        vehicleIncidentData = {},
        vehicleCallTaker = {},
        nameCallTaker = {},
        NameID = null,
        PropertyID = null,
        VehicleID = null,
        isHeader = false,
        incidentData = null,
        IncidentID = null,
        IncNo = null,
        isCAD = false,
        rIVSState = null,
        isRIVS = false,
        setRIVSState = null
    } = props;

    const localStoreData = useSelector((state) => state.Agency.localStoreData);
    const [viewMode, setViewMode] = useState('mix');
    const [searchListData, setSearchListData] = useState([]);
    const [tabState, setTabState] = useState('vin-container');
    const [viewSummary, setViewSummary] = useState(false);
    const [loginAgencyID, setLoginAgencyID] = useState('');
    const [suffixIdDrp, setSuffixIdDrp] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [raceIdDrp, setRaceIdDrp] = useState([]);
    const [ncicResponseData, setNcicResponseData] = useState([]);
    const [summaryData, setSummaryData] = useState(null);
    const [clickedRow, setClickedRow] = useState(null);
    const [isDisableSendButton, setIsDisableSendButton] = useState(false);
    const [responseSectionData, setResponseSectionData] = useState(null);
    const [activeWarrantHit, setActiveWarrantHit] = useState(false);
    const [ncicKeywordMatches, setNcicKeywordMatches] = useState({
        expiredLicensePlate: false,
        stolenVehicle: false,
        warrant: false,
    });
    const [soundOn, setSoundOn] = useState(true);
    const [isCompact, setIsCompact] = useState(false);
    const [ncicOnline, setNcicOnline] = useState(true);
    const [selectedNCICRows, setSelectedNCICRows] = useState([]);
    const [showIncidentSearchModal, setShowIncidentSearchModal] = useState(false);
    const [incidentSearchData, setIncidentSearchData] = useState([]);
    const [loadingIncidentSearch, setLoadingIncidentSearch] = useState(false);
    const [selectedIncident, setSelectedIncident] = useState(null);
    const [incidentSearchNumber, setIncidentSearchNumber] = useState('');
    const [incidentReportedDate, setIncidentReportedDate] = useState(null);
    const [incidentReportedDateTo, setIncidentReportedDateTo] = useState(null);
    const audioContextRef = useRef(null);
    const isAudioUnlockedRef = useRef(false);

    const getOrCreateAudioContext = () => {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) {
            return null;
        }

        if (!audioContextRef.current) {
            audioContextRef.current = new AudioContextClass();
        }

        return audioContextRef.current;
    };

    const unlockAudio = async () => {
        try {
            const audioContext = getOrCreateAudioContext();
            if (!audioContext) return;

            if (audioContext.state === 'suspended') {
                await audioContext.resume();
            }

            isAudioUnlockedRef.current = audioContext.state === 'running';
        } catch (error) {
            isAudioUnlockedRef.current = false;
        }
    };

    const playNcicNotificationSound = () => {
        try {
            const audioContext = getOrCreateAudioContext();
            if (!audioContext) return;
            if (audioContext.state !== 'running') return;

            const now = audioContext.currentTime;

            const firstOscillator = audioContext.createOscillator();
            const firstGain = audioContext.createGain();
            firstOscillator.type = 'triangle';
            firstOscillator.frequency.setValueAtTime(1046, now);
            firstGain.gain.setValueAtTime(0.0001, now);
            firstGain.gain.exponentialRampToValueAtTime(0.22, now + 0.01);
            firstGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.14);
            firstOscillator.connect(firstGain);
            firstGain.connect(audioContext.destination);
            firstOscillator.start(now);
            firstOscillator.stop(now + 0.14);

            const secondOscillator = audioContext.createOscillator();
            const secondGain = audioContext.createGain();
            secondOscillator.type = 'triangle';
            secondOscillator.frequency.setValueAtTime(1318, now + 0.17);
            secondGain.gain.setValueAtTime(0.0001, now + 0.17);
            secondGain.gain.exponentialRampToValueAtTime(0.2, now + 0.18);
            secondGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.32);
            secondOscillator.connect(secondGain);
            secondGain.connect(audioContext.destination);
            secondOscillator.start(now + 0.17);
            secondOscillator.stop(now + 0.32);
        } catch (error) {
            console.error("Unable to play NCIC notification sound:", error);
        }
    };

    useEffect(() => {
        if (!openNCICModal || !soundOn) {
            return;
        }

        const unlockOnce = async () => {
            if (!isAudioUnlockedRef.current) {
                await unlockAudio();
            }
        };

        window.addEventListener('pointerdown', unlockOnce, { passive: true });

        return () => {
            window.removeEventListener('pointerdown', unlockOnce);
        };
    }, [openNCICModal, soundOn]);
    useEffect(() => {
        if (isNameCallTaker) {
            setTabState('driver-license');
        }
    }, [isNameCallTaker]);

    useEffect(() => {
        const response = responseSectionData?.FormattedResponse || summaryData?.FormattedResponse || '';

        if (typeof response !== 'string' || !response) {
            setActiveWarrantHit(false);
            setNcicKeywordMatches({
                expiredLicensePlate: false,
                stolenVehicle: false,
                warrant: false,
            });
            return;
        }

        const normalizedText = response
            .replace(/<br\s*\/?>/gi, ' ')
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/gi, ' ')
            .replace(/\s+/g, ' ')
            .toUpperCase();

        const keywordMatches = {
            expiredLicensePlate: normalizedText.includes('EXPIRED LICENSE PLATE'),
            stolenVehicle: normalizedText.includes('STOLEN VEHICLE'),
            warrant: normalizedText.includes('WARRANT'),
        };

        setNcicKeywordMatches(keywordMatches);

        const hasColoredHit = response.indexOf("<span style='color: red;") >= 0 || response.indexOf("<span style='color: blue;") >= 0;
        setActiveWarrantHit(hasColoredHit || keywordMatches.stolenVehicle || keywordMatches.warrant);
    }, [responseSectionData?.FormattedResponse, summaryData?.FormattedResponse]);

    const [
        nameSectionState,
        setNameSectionState,
        handleNameSectionState,
        clearNameSectionState,
    ] = useObjState({
        id: "",
        isByRQ_RNQ_QM: "QM",
        lastName: "",
        firstName: "",
        middleName: "",
        suffix: "",
        sex: "",
        race: "",
        dob: ""
    });

    const [
        vehicleSectionState,
        setVehicleSectionState,
        handleVehicleSectionState,
        clearVehicleSectionState,
    ] = useObjState({
        id: "",
        isByRQ_RNQ_QM: "RQ",
        lastName: "",
        firstName: "",
        middleName: "",
        suffix: "",
        dob: "",
        plateNo: "",
        platExpires: "",
        playType: "",
        VIN: "",
        make: "",
        manuYear: "",
        plateState: "",
        createdDateTime: "",
    });

    const [
        wantedCheckSectionState,
        setWantedCheckSectionState,
        handleWantedCheckSectionState,
        clearWantedCheckSectionState,
    ] = useObjState({
        id: "",
        isByRSDW_RSDWW: "RQ",
        lastName: "",
        firstName: "",
        middleName: "",
        suffix: "",
        dob: "",
        plateNo: "",
        platExpires: "",
        playType: "",
        VIN: "",
        make: "",
        manuYear: "",
        plateState: "",
        createdDateTime: "",
    });

    const [
        driverLicenseSectionState,
        setDriverLicenseSectionState,
        handleDriverLicenseSectionState,
        clearDriverLicenseSectionState,
    ] = useObjState({
        id: "",
        isByRQ_RNQ_QM: "DQ",
        lastName: "",
        firstName: "",
        middleName: "",
        suffix: "",
        sex: "",
        rac: "",
        dob: "",
        st: "",
        oln: "",
        createdDateTime: "",
    });

    const [
        wantedSectionState,
        setWantedSectionState,
        handleWantedSectionState,
        clearWantedSectionState,
    ] = useObjState({
        id: "",
        isByRQ_RNQ_QM: "QM",
        lastName: "",
        firstName: "",
        middleName: "",
        suffix: "",
        sex: "",
        race: "",
        dob: ""
    });

    const [
        errorWantedSectionState,
        ,
        handleErrorWantedSectionState,
        clearErrorWantedSectionState,
    ] = useObjState({
        lastName: false,
        firstName: false,
        middleName: false,
        sex: false,
        race: false,
        DOB: false,
    });

    const [
        errorNameSectionState,
        setErrorNameSectionState,
        handleErrorNameSectionState,
        clearErrorNameSectionState,
    ] = useObjState({
        lastName: false,
        firstName: false,
        sex: false,
        race: false,
        dob: false,
    });

    const [
        errorDriverLicenseSectionState,
        setErrorDriverLicenseSectionState,
        handleErrorDriverLicenseSectionState,
        clearErrorDriverLicenseSectionState,
    ] = useObjState({
        lastName: false,
        firstName: false,
        sex: false,
        suffix: false,
        race: false,
        st: false,
        oln: false,
        dob: false,
    });

    const [
        errorStolenVehicleSectionState,
        setErrorStolenVehicleSectionState,
        handleErrorStolenVehicleSectionState,
        clearErrorStolenVehicleSectionState,
    ] = useObjState({
        licenseState: false,
        vehicleMake: false,
        licensePlate: false,
    });

    const [
        errorVehicleSectionState,
        setErrorVehicleSectionState,
        handleErrorVehicleSectionState,
        clearErrorVehicleSectionState,
    ] = useObjState({
        plateState: false,
        playType: false,
        plateNo: false,
        platExpires: false,
        VIN: false,
        lastName: false,
        firstName: false,
        suffix: false,
        dob: false,
    });

    const [
        plateTypeIdDrp,
        setPlateTypeIdDrp,
    ] = useState([]);

    const [
        makeIdDrp,
        setMakeIdDrp,
    ] = useState([]);

    const [
        stolenVehicleSectionState,
        setStolenVehicleSectionState,
        handleStolenVehicleSectionState,
        clearStolenVehicleSectionState,
    ] = useObjState({
        id: "",
        isByRQ_RNQ_QM: "QV",
        ncicNumber: "",
        licensePlate: "",
        licenseState: "",
        vin: "",
        vehicleMake: "",
        createdDateTime: "",
    });

    const [effectiveNcicScreenPermission, setEffectiveNcicScreenPermission] = useState(null);

    const getNCICResponseKey = `/NCICDetails/GetNCICResponse`;
    const { data: getNCICResponseData, isSuccess: isFetchNCICResponse, isError: isNoData, refetch: refetchNCICResponse } = useQuery(
        [getNCICResponseKey, {
            UserId: parseInt(localStoreData?.NCICLoginId),
            VehicleID: VehicleID,
            PropertyID: PropertyID,
            NameID: NameID,
            IncidentID: NameID ? null : PropertyID ? null : VehicleID ? null : IncidentID,
            AgencyID: localStoreData?.AgencyID,
        },],
        NcicServices.getNCICResponse,
        {
            refetchOnWindowFocus: false,
            enabled: !!parseInt(localStoreData?.NCICLoginId) && openNCICModal && !!localStoreData?.AgencyID && (!isRIVS || !!IncidentID),
            retry: 0,

        }
    );

    useEffect(() => {
        if (getNCICResponseData && isFetchNCICResponse) {
            const table = JSON.parse(getNCICResponseData.data.data).Table;
            if (table?.length > 0) {
                setNcicResponseData(table);
                handleSummary(table?.[0]); setClickedRow(table?.[0])
            }
        } else {
            setNcicResponseData([]);
        }
    }, [getNCICResponseData, isFetchNCICResponse]);

    useEffect(() => {
        if (!soundOn || !openNCICModal || !getNCICResponseData || !isFetchNCICResponse) {
            return;
        }

        playNcicNotificationSound();
    }, [getNCICResponseData, isFetchNCICResponse, openNCICModal, soundOn]);

    useEffect(() => {
        return () => {
            if (audioContextRef.current) {
                audioContextRef.current.close();
                audioContextRef.current = null;
            }
        };
    }, []);

    const sexIdDrp = [
        {
            value: 1,
            label: "Female",
            code: "F"
        },
        {
            value: 2,
            label: "Male",
            code: "M"
        },
        {
            value: 3,
            label: "Unknown",
            code: "U"
        }
    ]

    useEffect(() => {
        if (!!nameData?.LastName && !vehicleIncidentData?.VehicleNo) {
            setDriverLicenseSectionState({
                lastName: nameData?.LastName,
                firstName: nameData?.FirstName,
                middleName: nameData?.MiddleName,
                suffix: suffixIdDrp?.find(item => item?.value === nameData?.SuffixID)?.label,
                sex: sexIdDrp?.find(item => item?.value === nameData?.SexID)?.code,
                race: raceIdDrp?.find(item => item?.value === nameData?.RaceID)?.label,
                st: stateList?.find(item => item?.value === nameData?.DLStateID)?.label,
                dob: nameData?.DateOfBirth ? new Date(nameData?.DateOfBirth) : "",
            });
            setVehicleSectionState((prev) => ({
                ...prev,
                lastName: nameData?.LastName,
                firstName: nameData?.FirstName,
                middleName: nameData?.MiddleName,
                suffix: suffixIdDrp?.find(item => item?.value === nameData?.SuffixID)?.label,
                dob: nameData?.DateOfBirth ? new Date(nameData?.DateOfBirth) : "",
            }));
            setNameSectionState({
                lastName: nameData?.LastName,
                firstName: nameData?.FirstName,
                middleName: nameData?.MiddleName,
                suffix: suffixIdDrp?.find(item => item?.value === nameData?.SuffixID)?.label,
                sex: sexIdDrp?.find(item => item?.value === nameData?.SexID)?.code,
                race: raceIdDrp?.find(item => item?.value === nameData?.RaceID)?.label,
                age: nameData?.Age,
                ethnicity: nameData?.Ethnicity,
                eyes: nameData?.Eyes,
                hair: nameData?.Hair,
                height: nameData?.HeightFrom,
                height2: nameData?.HeightTo,
                weight: nameData?.WeightFrom,
                weight2: nameData?.WeightTo,
                st: stateList?.find(item => item?.value === nameData?.DLStateID)?.label,
                dob: nameData?.DateOfBirth ? new Date(nameData?.DateOfBirth) : "",
            })
            setWantedSectionState({
                DOB: nameData?.DateOfBirth ? new Date(nameData?.DateOfBirth) : "",
                lastName: nameData?.LastName,
                firstName: nameData?.FirstName,
                middleName: nameData?.MiddleName,
                suffix: suffixIdDrp?.find(item => item?.value === nameData?.SuffixID)?.label,
                sex: sexIdDrp?.find(item => item?.value === nameData?.SexID)?.code,
                race: raceIdDrp?.find(item => item?.value === nameData?.RaceID)?.label,
                age: nameData?.Age,
                ethnicity: nameData?.Ethnicity,
                eyes: nameData?.Eyes,
                hair: nameData?.Hair,
                height: nameData?.HeightFrom,
                height2: nameData?.HeightTo,
                weight: nameData?.WeightFrom,
                weight2: nameData?.WeightTo,
                createdDateTime: nameData?.CreatedDateTime,
                SMT: nameData?.SMT,
                MiscellaneousIDNumber: "",
                FBINumber: "",
                SSN: "",
            })
            setWantedCheckSectionState({
                lastName: nameData?.LastName,
                firstName: nameData?.FirstName,
                middleName: nameData?.MiddleName,
                suffix: suffixIdDrp?.find(item => item?.value === nameData?.SuffixID)?.label,
                dob: nameData?.DateOfBirth ? new Date(nameData?.DateOfBirth) : "",
                plateNo: "",
                platExpires: "",
                playType: "",
                VIN: "",
                make: "",
                manuYear: "",
                plateState: "",
                createdDateTime: "",
                sex: sexIdDrp?.find(item => item?.value === nameData?.SexID)?.code,
                race: raceIdDrp?.find(item => item?.value === nameData?.RaceID)?.label,
                age: nameData?.Age,
            })
        }
    }, [nameData, raceIdDrp, suffixIdDrp, stateList, tabState, openNCICModal]);

    useEffect(() => {
        const currentFirstName = nameCallTaker?.FirstName || "";
        const currentLastName = nameCallTaker?.LastName || "";

        if (nameCallTaker && !vehicleIncidentData?.VehicleNo) {
            setDriverLicenseSectionState({
                lastName: currentLastName,
                firstName: currentFirstName,
                middleName: "",
                suffix: "",
                sex: "",
                race: "",
                st: "",
                dob: "",
            });
            setVehicleSectionState((prev) => ({
                ...prev,
                lastName: currentLastName,
                firstName: currentFirstName,
                middleName: "",
                suffix: "",
                dob: "",
            }));
            setNameSectionState({
                lastName: currentLastName,
                firstName: currentFirstName,
                middleName: "",
                suffix: "",
                sex: "",
                race: "",
                age: "",
                ethnicity: "",
                eyes: "",
                hair: "",
                height: "",
                height2: "",
                weight: "",
                weight2: "",
                st: "",
                dob: "",
            })
            setWantedSectionState({
                DOB: "",
                lastName: currentLastName,
                firstName: currentFirstName,
                middleName: "",
                suffix: "",
                sex: "",
                race: "",
                dob: "",
            })
            setWantedCheckSectionState({
                lastName: currentLastName,
                firstName: currentFirstName,
                middleName: "",
                suffix: "",
                dob: "",
                plateNo: "",
                platExpires: "",
                playType: "",
                VIN: "",
                make: "",
                manuYear: "",
                plateState: "",
                createdDateTime: "",
                sex: "",
                race: "",
                age: "",
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nameCallTaker?.FirstName, nameCallTaker?.LastName, nameData?.LastName, tabState, openNCICModal]);

    useEffect(() => {
        if (!!vehicleIncidentData?.VehicleNo) {
            setVehicleSectionState((prev) => ({
                ...prev,
                id: "",
                isByRQ_RNQ_QM: "RQ",
                lastName: "",
                firstName: "",
                middleName: "",
                suffix: "",
                dob: "",
                plateNo: vehicleIncidentData?.VehicleNo,
                platExpires: vehicleIncidentData?.PlateExpireDtTm ? new Date(vehicleIncidentData?.PlateExpireDtTm) : "",
                playType: plateTypeIdDrp?.find(item => item?.value === vehicleIncidentData?.PlateTypeID)?.shortCode,
                VIN: vehicleIncidentData?.VIN,
                make: vehicleIncidentData?.MakeID,
                manuYear: vehicleIncidentData?.ManufactureYear,
                plateState: stateList?.find(item => item?.value === vehicleIncidentData?.PlateID)?.label,
                createdDateTime: vehicleIncidentData?.ReportedDtTm ? new Date(vehicleIncidentData?.ReportedDtTm) : "",
            }));
            setStolenVehicleSectionState((prev) => ({
                ...prev,
                id: "",
                isByRQ_RNQ_QM: "QV",
                ncicNumber: "",
                licensePlate: "",
                licenseState: "",
                vin: "",
                vehicleMake: vehicleIncidentData?.MakeID,
                createdDateTime: vehicleIncidentData?.ReportedDtTm ? new Date(vehicleIncidentData?.ReportedDtTm) : "",
            }));
        }
    }, [vehicleIncidentData?.VehicleNo, makeIdDrp, plateTypeIdDrp, stateList, tabState, openNCICModal])

    useEffect(() => {
        const currentPlate = vehicleCallTaker?.Plate || "";
        const currentPlateTypeCode = vehicleCallTaker?.PlateTypeCode != null ? Number(vehicleCallTaker.PlateTypeCode) : null;
        const currentTagYear = vehicleCallTaker?.TagYear != null ? vehicleCallTaker.TagYear : "";
        const currentStateCode = vehicleCallTaker?.StateCode != null ? Number(vehicleCallTaker.StateCode) : null;

        if (vehicleCallTaker && !vehicleIncidentData?.VehicleNo) {
            // Find plate type - ensure we compare numbers
            const plateTypeItem = plateTypeIdDrp?.find(item => Number(item?.value) === currentPlateTypeCode);
            const playTypeValue = plateTypeItem?.shortCode || "";

            // Find state - ensure we compare numbers
            const stateItem = stateList?.find(item => Number(item?.value) === currentStateCode);
            const plateStateValue = stateItem?.label || "";

            setVehicleSectionState((prev) => ({
                ...prev,
                id: "",
                isByRQ_RNQ_QM: "RQ",
                lastName: "",
                firstName: "",
                middleName: "",
                suffix: "",
                dob: "",
                plateNo: currentPlate,
                platExpires: "",
                playType: playTypeValue,
                VIN: "",
                make: "",
                manuYear: currentTagYear,
                plateState: plateStateValue,
                createdDateTime: "",
            }));
            setStolenVehicleSectionState((prev) => ({
                ...prev,
                id: "",
                isByRQ_RNQ_QM: "QV",
                ncicNumber: "",
                licensePlate: "",
                licenseState: "",
                vin: "",
                vehicleMake: "",
                createdDateTime: "",
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicleCallTaker?.Plate, vehicleCallTaker?.PlateTypeCode, vehicleCallTaker?.TagYear, vehicleCallTaker?.StateCode, plateTypeIdDrp, stateList, tabState, openNCICModal])

    useEffect(() => {
        if (rIVSState && isRIVS) {
            setDriverLicenseSectionState({
                lastName: rIVSState?.LastName,
                firstName: rIVSState?.FirstName,
                middleName: rIVSState?.MiddleName,
                suffix: suffixIdDrp?.find(item => item?.value === nameData?.SuffixID)?.label,
                sex: "",
                race: "",
                st: stateList?.find(item => item?.value === rIVSState?.StateCode)?.label,
                dob: "",
            });
            setVehicleSectionState((prev) => ({
                ...prev,
                lastName: rIVSState?.LastName,
                firstName: rIVSState?.FirstName,
                middleName: rIVSState?.MiddleName,
                suffix: "",
                dob: "",
                plateNo: rIVSState?.VehiclePlate,
                platExpires: "",
                playType: plateTypeIdDrp?.find(item => item?.value === rIVSState?.PlateTypeCode)?.shortCode,
                VIN: "",
                make: "",
                manuYear: rIVSState?.TagYear,
                plateState: stateList?.find(item => item?.value === rIVSState?.StateCode)?.label,
            }));
            setNameSectionState({
                lastName: rIVSState?.LastName,
                firstName: rIVSState?.FirstName,
                middleName: rIVSState?.MiddleName,
                suffix: "",
                sex: "",
                race: "",
                age: "",
                ethnicity: "",
                eyes: "",
                hair: "",
                height: "",
                height2: "",
                weight: "",
                weight2: "",
                st: stateList?.find(item => item?.value === rIVSState?.StateCode)?.label,
                dob: "",
            })
            setWantedSectionState({
                DOB: "",
                lastName: rIVSState?.LastName,
                firstName: rIVSState?.FirstName,
                middleName: rIVSState?.MiddleName,
                suffix: "",
                sex: "",
                race: "",
                age: "",
                ethnicity: "",
                eyes: "",
                hair: "",
                height: "",
                height2: "",
                weight: "",
                weight2: "",
            })
            setWantedCheckSectionState({
                lastName: rIVSState?.LastName,
                firstName: rIVSState?.FirstName,
                middleName: rIVSState?.MiddleName,
                suffix: "",
                dob: "",
                plateNo: rIVSState?.VehiclePlate,
                platExpires: "",
                playType: plateTypeIdDrp?.find(item => item?.value === rIVSState?.PlateTypeCode)?.shortCode,
                VIN: "",
                make: "",
                manuYear: "",
                plateState: stateList?.find(item => item?.value === rIVSState?.DLStateID)?.label,
                createdDateTime: "",
                sex: "",
                race: "",
                age: "",
            })
        }
    }, [rIVSState, isRIVS, raceIdDrp, suffixIdDrp, stateList, tabState, openNCICModal]);

    // Sync NCIC section state data back to RIVS state when user enters data in NCIC (isRIVS context)
    useEffect(() => {
        if (!isRIVS || !setRIVSState || !openNCICModal) return;

        const lastName = nameSectionState?.lastName || driverLicenseSectionState?.lastName || vehicleSectionState?.lastName || wantedSectionState?.lastName || wantedCheckSectionState?.lastName || "";
        const firstName = nameSectionState?.firstName || driverLicenseSectionState?.firstName || vehicleSectionState?.firstName || wantedSectionState?.firstName || wantedCheckSectionState?.firstName || "";
        const middleName = nameSectionState?.middleName || driverLicenseSectionState?.middleName || vehicleSectionState?.middleName || wantedSectionState?.middleName || wantedCheckSectionState?.middleName || "";

        const plateNo = vehicleSectionState?.plateNo || wantedCheckSectionState?.plateNo || "";
        const plateStateLabel = vehicleSectionState?.plateState || wantedCheckSectionState?.plateState || "";
        const playTypeShortCode = vehicleSectionState?.playType || wantedCheckSectionState?.playType || "";
        const manuYear = vehicleSectionState?.manuYear || wantedCheckSectionState?.manuYear || "";

        const dlStateLabel = driverLicenseSectionState?.st || "";
        const oln = driverLicenseSectionState?.oln || "";

        const stateCodeValue = plateStateLabel && stateList?.length ? (stateList.find((item) => item?.label === plateStateLabel)?.value ?? "") : "";
        const plateTypeCodeValue = playTypeShortCode && plateTypeIdDrp?.length ? (plateTypeIdDrp.find((item) => item?.shortCode === playTypeShortCode)?.value ?? "") : "";
        const dlStateIdValue = dlStateLabel && stateList?.length ? (stateList.find((item) => item?.label === dlStateLabel)?.value ?? "") : "";

        const hasAnyValue = lastName || firstName || middleName || plateNo || stateCodeValue || plateTypeCodeValue || manuYear || dlStateIdValue || oln;
        if (!hasAnyValue) return;

        setRIVSState((prev) => ({
            ...prev,
            LastName: lastName,
            FirstName: firstName,
            MiddleName: middleName,
            VehiclePlate: plateNo,
            StateCode: stateCodeValue,
            PlateTypeCode: plateTypeCodeValue,
            TagYear: manuYear || prev?.TagYear,
            DLStateID: dlStateIdValue,
            DLNumber: oln,
        }));
    }, [
        isRIVS,
        setRIVSState,
        openNCICModal,
        nameSectionState?.lastName,
        nameSectionState?.firstName,
        nameSectionState?.middleName,
        vehicleSectionState?.plateNo,
        vehicleSectionState?.plateState,
        vehicleSectionState?.playType,
        vehicleSectionState?.manuYear,
        vehicleSectionState?.lastName,
        vehicleSectionState?.firstName,
        vehicleSectionState?.middleName,
        driverLicenseSectionState?.lastName,
        driverLicenseSectionState?.firstName,
        driverLicenseSectionState?.middleName,
        driverLicenseSectionState?.st,
        driverLicenseSectionState?.oln,
        wantedSectionState?.lastName,
        wantedSectionState?.firstName,
        wantedSectionState?.middleName,
        wantedCheckSectionState?.lastName,
        wantedCheckSectionState?.firstName,
        wantedCheckSectionState?.middleName,
        wantedCheckSectionState?.plateNo,
        wantedCheckSectionState?.plateState,
        wantedCheckSectionState?.playType,
        wantedCheckSectionState?.manuYear,
        stateList,
        plateTypeIdDrp,
    ]);

    const onCloseNCICModal = () => {
        setOpenNCICModal(false);
        setViewMode('mix');
        setTabState('vin-container'); // Reset to default tab
        setViewSummary(false);
        clearDriverLicenseSectionState();
        clearWantedSectionState();
        clearNameSectionState();
        clearVehicleSectionState();
        clearStolenVehicleSectionState();
        clearErrorWantedSectionState();
        clearErrorVehicleSectionState();
        clearErrorNameSectionState();
        clearErrorDriverLicenseSectionState();
        clearErrorStolenVehicleSectionState();
        setIsNameCallTaker(false);
        setSummaryData(null);
        setNcicResponseData([]);
        setSelectedNCICRows([]); // Clear selected rows when modal closes
        handleClearSearch();
    };

    const runIncidentSearch = () => {
        const value = {
            'AgencyID': localStoreData?.AgencyID,
            'PINID': localStoreData?.PINID,
            'ReportedDate': incidentReportedDate ? getShowingDateText(incidentReportedDate) : '',
        };
        if (isCAD) {
            value.ReportedDateTO = incidentReportedDateTo ? getShowingDateText(incidentReportedDateTo) : '';
        } else {
            value.ReportedDateTo = incidentReportedDateTo ? getShowingDateText(incidentReportedDateTo) : '';
        }
        setLoadingIncidentSearch(true);
        fetchPostData(isCAD ? 'CAD/QueryIncident/IncidentEventSearch' : 'Incident/Search_Incident', value).then((res) => {
            setLoadingIncidentSearch(false);
            if (res && res.length > 0) {
                setIncidentSearchData(res);
            } else {
                toastifyError("No Data Available");
                setIncidentSearchData([]);
            }
        }).catch((error) => {
            setLoadingIncidentSearch(false);
            toastifyError("Error fetching incident data");
            setIncidentSearchData([]);
        });
    };

    const handleAttachToIncident = () => {
        setShowIncidentSearchModal(true);
        setSelectedIncident(null); // Clear selection when opening modal
        runIncidentSearch();
    };

    const handleSaveIncident = async () => {
        const responseIds = selectedNCICRows
            .map(row => row?.ResponseId)
            .filter(id => id != null && id !== undefined)
            .join(',');
        const payload = {
            'IncidentID': selectedIncident?.IncidentID,
            'ResponseIDs': responseIds,
        }
        const res = await NcicServices.attachNCICToIncident(payload)
        if (res) {
            toastifySuccess("NCIC attached to incident successfully");
            setShowIncidentSearchModal(false);
            setIncidentSearchData([]);
            setSelectedIncident(null);
            setIncidentSearchNumber('');
            setIncidentReportedDate(null);
            setIncidentReportedDateTo(null);
            refetchNCICResponse();
        } else {
            toastifyError("Failed to attach NCIC to incident");
        }
    };

    // Logic to set view based on button clicks
    const handleMixClick = () => {
        setResponseSectionData(null);
        setViewMode('mix');
    };
    const handleResponseClick = () => {
        setViewMode('response');
    };

    const handleRequestClick = () => {
        setResponseSectionData(null);
        setViewMode('request');
    };

    const handleClearSearch = () => {
        clearVehicleSectionState();
        clearNameSectionState();
        clearErrorVehicleSectionState();
        clearErrorNameSectionState();
        clearErrorWantedSectionState();
        clearErrorDriverLicenseSectionState();
        clearErrorStolenVehicleSectionState();
        clearStolenVehicleSectionState();
        clearWantedCheckSectionState();
        clearDriverLicenseSectionState();
        clearWantedSectionState();
        setResponseSectionData(null);
    };
    function handelChangeTab(tab) {
        clearNameSectionState();
        clearVehicleSectionState();
        clearWantedCheckSectionState();
        clearDriverLicenseSectionState();
        clearWantedSectionState();
        clearErrorWantedSectionState();
        clearErrorVehicleSectionState();
        clearErrorNameSectionState();
        clearErrorDriverLicenseSectionState();
        clearErrorStolenVehicleSectionState();
        clearStolenVehicleSectionState();
        setTabState(tab);
    }

    useEffect(() => {
        const data = localStorage.getItem('NCICSearchList');
        if (data) {
            setSearchListData(JSON.parse(data));
        }
    }, [tabState]);

    useEffect(() => {
        if (localStoreData) {
            setLoginAgencyID(localStoreData?.AgencyID);
            getNcicScreenPermission(localStoreData?.AgencyID, localStoreData?.PINID);
        }
    }, [localStoreData]);

    const getNcicScreenPermission = (aId, pinID) => {
        try {
            ScreenPermision("CN101", aId, pinID).then(res => {
                if (res) {
                    setEffectiveNcicScreenPermission(res);
                }
                else {
                    setEffectiveNcicScreenPermission(null);
                }
            });
        } catch (error) {
            console.error('There was an error!', error);
            setEffectiveNcicScreenPermission(null);
        }
    }


    const get_Name_Drp_Data = (loginAgencyID) => {
        const val = { AgencyID: loginAgencyID, }
        fetchPostData('MasterName/GetNameDropDown', val).then((data) => {
            if (data) {
                setSuffixIdDrp(Comman_changeArrayFormat(data[0]?.Suffix, 'SuffixID', 'Description'));
                setStateList(Comman_changeArrayFormat(data[0]?.State, "StateID", "State"));
                setRaceIdDrp(Comman_changeArrayFormat(data[0]?.Race, 'RaceTypeID', 'Description'));
            } else {
                setSuffixIdDrp([]);
                setStateList([]);
                setRaceIdDrp([]);
            }
        })
    };

    const get_PlateType_Drp = (loginAgencyID) => {
        const val = {
            AgencyID: loginAgencyID,
        }
        fetchPostData('PropertyVehiclePlateType/GetDataDropDown_PropertyVehiclePlateType', val).then((data) => {
            if (data) {
                setPlateTypeIdDrp(Comman_changeArrayFormat3(data, 'PlateTypeID', 'Description', 'shortCode', 'PlateTypeCode'));
            } else {
                setPlateTypeIdDrp([]);
            }
        })
    }

    const get_MakeId_Drp = (loginAgencyID) => {
        const val = {
            AgencyID: loginAgencyID,
        }
        fetchPostData('PropertyVehicleMake/GetDataDropDown_PropertyVehicleMake', val).then((data) => {
            if (data) {
                setMakeIdDrp(Comman_changeArrayFormat(data, 'PropertyVehicleMakeID', 'Description'))
            } else {
                setMakeIdDrp([]);
            }
        })
    }


    useEffect(() => {
        if (loginAgencyID) {
            get_Name_Drp_Data(loginAgencyID)
            get_PlateType_Drp(loginAgencyID)
            get_MakeId_Drp(loginAgencyID)
        }

    }, [loginAgencyID])

    const validateFormVehicleSectionState = () => {
        let isError = false;

        if (vehicleSectionState?.isByRQ_RNQ_QM === 'RQ') {
            const requiredFields = ['plateState', 'plateNo', 'platExpires'];

            requiredFields.forEach((field) => {
                const value = vehicleSectionState[field];

                if (field === 'platExpires') {
                    // Special handling for platExpires field (can be Date object or string)
                    if (!value || value === '' || value === null || value === undefined ||
                        (value instanceof Date && isNaN(value.getTime()))) {
                        handleErrorVehicleSectionState(field, true);
                        isError = true;
                    } else {
                        handleErrorVehicleSectionState(field, false);
                    }
                } else {
                    // Regular validation for other fields
                    if (isEmptyCheck(value)) {
                        handleErrorVehicleSectionState(field, true);
                        isError = true;
                    } else {
                        handleErrorVehicleSectionState(field, false);
                    }
                }
            });
        } else if (vehicleSectionState?.isByRQ_RNQ_QM === 'RNQ') {
            const requiredFields = ['lastName', 'firstName', 'dob'];

            requiredFields.forEach((field) => {
                const value = vehicleSectionState[field];

                if (field === 'dob') {
                    // Special handling for dob field
                    if (!value || value === '' || value === null || value === undefined) {
                        handleErrorVehicleSectionState(field, true);
                        isError = true;
                    } else {
                        handleErrorVehicleSectionState(field, false);
                    }
                } else {
                    // Regular validation for other fields
                    if (isEmptyCheck(value)) {
                        handleErrorVehicleSectionState(field, true);
                        isError = true;
                    } else {
                        handleErrorVehicleSectionState(field, false);
                    }
                }
            });
        }

        return !isError;
    };

    const validateFormWantedSectionState = () => {
        let isError = false;

        const requiredFields = ['lastName', 'firstName', 'race', 'dob', 'sex'];

        requiredFields.forEach((field) => {
            const value = wantedSectionState[field];

            if (field === 'dob') {
                // Special handling for dob field
                if (!value || value === '' || value === null || value === undefined) {
                    handleErrorWantedSectionState(field, true);
                    isError = true;
                } else {
                    handleErrorWantedSectionState(field, false);
                }
            } else {
                // Regular validation for other fields
                if (isEmptyCheck(value)) {
                    handleErrorWantedSectionState(field, true);
                    isError = true;
                } else {
                    handleErrorWantedSectionState(field, false);
                }
            }
        });

        return !isError;
    };
    const validateFormNameSectionState = () => {
        let isError = false;

        const requiredFields = ['lastName', 'firstName', 'sex', 'race', 'dob'];

        requiredFields.forEach((field) => {
            const value = nameSectionState[field];

            if (field === 'dob') {
                // Special handling for dob field
                if (!value || value === '' || value === null || value === undefined) {
                    handleErrorNameSectionState(field, true);
                    isError = true;
                } else {
                    handleErrorNameSectionState(field, false);
                }
            } else {
                // Regular validation for other fields
                if (isEmptyCheck(value)) {
                    handleErrorNameSectionState(field, true);
                    isError = true;
                } else {
                    handleErrorNameSectionState(field, false);
                }
            }
        });

        return !isError;
    };

    const validateFormDriverLicenseSectionState = () => {
        let isError = false;
        const requireOLN = isEmptyCheck(driverLicenseSectionState?.lastName) && isEmptyCheck(driverLicenseSectionState?.firstName);
        const alwaysRequiredFields = ['st'];
        if (requireOLN) alwaysRequiredFields.push('oln');

        // Validate always required fields (skip any null/undefined entries)
        alwaysRequiredFields.filter(Boolean).forEach((field) => {
            const value = driverLicenseSectionState ? driverLicenseSectionState[field] : undefined;

            if (field === 'dob') {
                if (!value && value !== 0) {
                    handleErrorDriverLicenseSectionState(field, true);
                    isError = true;
                } else {
                    handleErrorDriverLicenseSectionState(field, false);
                }
            } else {
                if (isEmptyCheck(value)) {
                    handleErrorDriverLicenseSectionState(field, true);
                    isError = true;
                } else {
                    handleErrorDriverLicenseSectionState(field, false);
                }
            }
        });

        return !isError;
    };

    const validateFormStolenVehicleSectionState = () => {
        let isError = false;
        const hasVin = !isEmptyCheck(stolenVehicleSectionState?.vin);
        if (hasVin) {
            const value = stolenVehicleSectionState.vin;
            if (isEmptyCheck(value)) {
                handleErrorStolenVehicleSectionState('vin', true);
                isError = true;
            } else {
                handleErrorStolenVehicleSectionState('vin', false);
            }
            handleErrorStolenVehicleSectionState('licenseState', false);
            handleErrorStolenVehicleSectionState('licensePlate', false);
        } else {
            const requiredFields = ['licenseState', 'licensePlate'];
            requiredFields.forEach((field) => {
                const value = stolenVehicleSectionState[field];
                if (isEmptyCheck(value)) {
                    handleErrorStolenVehicleSectionState(field, true);
                    isError = true;
                } else {
                    handleErrorStolenVehicleSectionState(field, false);
                }
            });
            handleErrorStolenVehicleSectionState('vin', false);
        }
        return !isError;
    };

    // Helper function to create base payload structure
    const createBasePayload = (messageKey, requestType, queryType) => ({
        MessageKey: messageKey,
        RequestType: requestType,
        QueryType: queryType,
        PIN: localStoreData?.PIN,
        AgencyID: localStoreData?.AgencyID,
        TerminalId: localStoreData?.NCICLoginTerminalID,
        PINID: parseInt(localStoreData?.PINID),
        UserId: localStoreData?.NCICLoginId,
        ORI: localStoreData?.NCICORI,
        NCICUserId: localStoreData?.NCICLoginId,
        PASSWORD: localStoreData?.NCICLoginPassword,
        ResourceNumber: "",
        NameID: NameID,
        PropertyID: PropertyID,
        VehicleID: VehicleID,
        IncidentID: NameID ? null : PropertyID ? null : VehicleID ? null : IncidentID,
    });

    const formatDateForAPI = (date) => {
        return date ? new Date(date).toLocaleDateString("en-US") : "";
    };

    const sendRequestAndRefetch = async (payload) => {
        try {
            setIsDisableSendButton(true);
            const res = await NcicServices.sendNcicRequest(payload);
            if (res) {
                setTimeout(() => {
                    refetchNCICResponse();
                }, 3000);
            }
        } catch (error) {
            console.error("NCIC request failed:", error);
        } finally {
            setIsDisableSendButton(false);
        }
    };

    // Payload builders for different request types
    const buildDriverLicensePayload = () => {
        const basePayload = createBasePayload("TXPR004", "PERSON", "DQ");
        return {
            ...basePayload,
            Person: {
                CDL: "",
                IMQ: "",
                SEX: driverLicenseSectionState?.sex,
                RSN: "",
                LNAME: driverLicenseSectionState?.lastName,
                FNAME: driverLicenseSectionState?.firstName,
                MNAME: driverLicenseSectionState?.middleName,
                SUFFIX: driverLicenseSectionState?.suffix,
                DOB: formatDateForAPI(driverLicenseSectionState?.dob),
                OLN: driverLicenseSectionState?.oln,
                CTL: "",
                DESTSTATE1: driverLicenseSectionState?.st,
                EML: "",
            }
        };
    };

    const buildWantedPayload = () => {
        const basePayload = createBasePayload("TXPR002", "PERSON", "QW");
        return {
            ...basePayload,
            Person: {
                LNAME: nameSectionState?.lastName,
                FNAME: nameSectionState?.firstName,
                MNAME: nameSectionState?.middleName,
                SUFFIX: nameSectionState?.suffix,
                SEX: nameSectionState?.sex,
                RACE: nameSectionState?.race,
                DOB: formatDateForAPI(nameSectionState?.dob),
            }
        };
    };

    const buildVehiclePayload = () => {
        if (vehicleSectionState?.isByRQ_RNQ_QM === "RQ") {
            const basePayload = createBasePayload("TXVH003", "VEHICLE", vehicleSectionState?.isByRQ_RNQ_QM);
            return {
                ...basePayload,
                Vehicle: {
                    VMA: "",
                    LIT: vehicleSectionState?.playType,
                    LIC: vehicleSectionState?.plateNo,
                    LIY: vehicleSectionState.platExpires ? new Date(vehicleSectionState.platExpires).getFullYear().toString() : "",
                    DESTSTATE1: vehicleSectionState?.plateState,
                    VIN: vehicleSectionState?.VIN,
                }
            };
        } else if (vehicleSectionState?.isByRQ_RNQ_QM === "RNQ") {
            const basePayload = createBasePayload("TXVH004", "VEHICLE", vehicleSectionState?.isByRQ_RNQ_QM);
            return {
                ...basePayload,
                Person: {
                    LNAME: vehicleSectionState?.lastName,
                    FNAME: vehicleSectionState?.firstName,
                    MNAME: vehicleSectionState?.middleName,
                    SUFFIX: vehicleSectionState.suffix,
                    DOB: formatDateForAPI(vehicleSectionState?.dob),
                }
            };
        }
        return null;
    };

    const buildStolenVehiclePayload = () => {
        const basePayload = createBasePayload("TXVH001", "VEHICLE", "QV");
        return {
            ...basePayload,
            Vehicle: {
                LIS: stolenVehicleSectionState?.licenseState,
                VMA: stolenVehicleSectionState?.vehicleMake,
                LIC: stolenVehicleSectionState?.licensePlate,
                NIC: stolenVehicleSectionState?.ncicNumber,
                VIN: stolenVehicleSectionState?.vin,
            }
        };
    };

    // Validation and payload mapping
    const tabConfigurations = {
        "driver-license": {
            validator: validateFormDriverLicenseSectionState,
            payloadBuilder: buildDriverLicensePayload
        },
        "wanted-container": {
            validator: validateFormWantedSectionState,
            payloadBuilder: buildWantedPayload
        },
        "vin-container": {
            validator: validateFormVehicleSectionState,
            payloadBuilder: buildVehiclePayload
        },
        "stolen-vehicle": {
            validator: validateFormStolenVehicleSectionState,
            payloadBuilder: buildStolenVehiclePayload
        }
    };

    async function handleSendClick() {
        const config = tabConfigurations[tabState];
        if (!config) {
            console.warn(`No configuration found for tab state: ${tabState}`);
            return;
        }
        if (!config.validator()) {
            return;
        }
        const payload = config.payloadBuilder();
        if (!payload) {
            console.error(`Failed to build payload for tab state: ${tabState}`);
            return;
        }
        await sendRequestAndRefetch(payload);
    }

    const handleSummary = async (row) => {
        setClickedRow(row);
        const ncicState = row?.DisplayString ? row.DisplayString.slice(-2) : '';
        const payload = {
            "ResponseType": row?.ResponseType,
            "Hit": row?.hit,
            "RequestDateTime": row?.RequestDateTime,
            "QueryType": row?.QueryType,
            "DisplayString": row?.DisplayString,
            "RequestId": row?.requestid,
            "ResponseId": row?.ResponseId,
            "AgencyId": localStoreData?.AgencyID,
            "NcicState": "TX"
        }
        const res = await NcicServices.getNCICParsedResponse(payload);

        if (res) {
            setSummaryData(res?.data);
            setViewSummary(true);
        }
    }

    const conditionalRowStyles = [
        {
            when: row => row?.hit === true,
            style: {
                color: 'red',
                backgroundColor: 'darkorange',
                cursor: 'pointer',
            },
        }
    ];

    const column = [
        // Checkbox column - only show when isHeader is true
        ...(isHeader ? [{
            name: (
                <input
                    type="checkbox"
                    checked={ncicResponseData.length > 0 && selectedNCICRows.length > 0 && selectedNCICRows.length === ncicResponseData.length}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setSelectedNCICRows([...ncicResponseData]);
                        } else {
                            setSelectedNCICRows([]);
                        }
                    }}
                    style={{ cursor: 'pointer' }}
                />
            ),
            cell: (row) => {
                const isSelected = selectedNCICRows.some(selected =>
                    (selected.requestid && row.requestid && selected.requestid === row.requestid) ||
                    (selected === row)
                );
                return (
                    <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setSelectedNCICRows(prev => [...prev, row]);
                            } else {
                                setSelectedNCICRows(prev => prev.filter(selected => {
                                    if (selected.requestid && row.requestid) {
                                        return selected.requestid !== row.requestid;
                                    }
                                    return selected !== row;
                                }));
                            }
                        }}
                        style={{ cursor: 'pointer' }}
                    />
                );
            },
            sortable: false,
            width: '50px',
            center: true,
        }] : []),
        {
            name: "",
            cell: (row) => (
                <button
                    type="button"
                    data-toggle="modal"
                    data-target="#WhiteboardSearchModal"
                    className="btn btn-sm bg-green text-white m-1"
                    onClick={() => { handleSummary(row); setClickedRow(row); }}
                >
                    Summary
                </button>
            ),
            sortable: true,
            width: '120px',
            center: true,
        },
        {
            name: 'Request Criteria',
            selector: row => row?.DisplayString,
            sortable: true,
            style: {
                position: "static",
            },
            cell: (row) => (
                <Tooltip text={row?.DisplayString || ''} isRight maxLength={23} />
            ),
            width: "230px",
        },
        {
            name: "Query Type",
            selector: (row) => (row.QueryType ? row.QueryType : ""),
            sortable: true,
            sortFunction: (rowA, rowB) => compareStrings(rowA.QueryType, rowB.QueryType),
            width: "120px",
        },
        {
            name: "Hit",
            selector: (row) => row.hit ? "True" : "False",
            sortable: true,
            sortFunction: (rowA, rowB) => compareStrings(rowA.hit, rowB.hit),
            width: "100px",
        },
        {
            name: "Request Date Time",
            selector: (row) => (row.RequestDateTime ? getShowingMonthDateYear(row.RequestDateTime) : ""),
            sortable: true,
            sortFunction: (rowA, rowB) => compareStrings(rowA.RequestDateTime, rowB.RequestDateTime),
            width: "150px",
        },
        {
            name: "Response Type",
            selector: (row) => row.ResponseType ? row.ResponseType : "",
            sortable: true,
            sortFunction: (rowA, rowB) => compareStrings(rowA.ResponseType, rowB.ResponseType),
            width: "130px",
        },
    ];


    // useEffect(() => {
    //     const fetchSummaryData = async () => {
    //         setClickedRow(ncicResponseData?.[0]);
    //         const payload = {
    //             "ResponseType": ncicResponseData?.[0]?.ResponseType,
    //             "Hit": ncicResponseData?.[0]?.hit,
    //             "RequestDateTime": ncicResponseData?.[0]?.RequestDateTime,
    //             "QueryType": ncicResponseData?.[0]?.QueryType,
    //             "DisplayString": ncicResponseData?.[0]?.DisplayString,
    //             "RequestId": ncicResponseData?.[0]?.requestid,
    //             "ResponseId": ncicResponseData?.[0]?.ResponseId,
    //             "AgencyId": loginAgencyID,
    //             "NcicState": "TX"
    //         }
    //         const res = await NcicServices.getNCICParsedResponse(payload);
    //         if (res) {
    //             setSummaryData(res?.data);
    //             setViewSummary(true);
    //         }
    //     }
    //     if (ncicResponseData?.length > 0) {
    //         fetchSummaryData();
    //     };
    // }, [ncicResponseData])
    const matchedNcicKeywords = [
        ncicKeywordMatches?.expiredLicensePlate ? 'EXPIRED LICENSE PLATE' : null,
        ncicKeywordMatches?.stolenVehicle ? 'STOLEN VEHICLE' : null,
        ncicKeywordMatches?.warrant ? 'WARRANT' : null,
    ].filter(Boolean);

    return (
        <>
            <div className="cad-css">
                {openNCICModal ? (
                    <>
                        <dialog
                            className="modal fade"
                            style={{
                                background: "rgba(0,0,0, 0.5)",
                                zIndex: "200",
                                overflowY: "hidden",
                                display: "block"
                            }}
                            id="NCICModal"
                            tabIndex="-1"
                            aria-hidden="false"
                            data-backdrop="false"
                        >
                            <div className="modal-dialog modal-dialog-centered modal-xl" style={{ maxHeight: '90vh' }}>
                                <div className="modal-content modal-content-ncic"
                                    style={{
                                        maxHeight: '90vh',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        overflowX: "hidden",
                                    }}
                                >
                                    <div className="modal-body modal-body-ncic" style={{ padding: "0", display: "flex", flexDirection: "column", overflowY: "auto", flex: "1" }}>
                                        <div className="modal-main-ncic" style={{ flex: "1", overflow: "hidden" }}>
                                            {/* Warrant / Hit warning banner — shown when activeWarrantHit is true */}
                                            {/* {activeWarrantHit && (
                                                <div
                                                    className="row mb-0"
                                                    style={{
                                                        backgroundColor: '#dc3545',
                                                        color: '#fff',
                                                        padding: '8px 12px',
                                                        textAlign: 'center',
                                                        fontWeight: 600,
                                                        letterSpacing: 0.5,
                                                        textTransform: 'uppercase',
                                                    }}
                                                >
                                                    <div className="col-12 p-0 d-flex align-items-center justify-content-center">
                                                        <span style={{ marginRight: 8 }} aria-hidden>⚠</span>
                                                        <span>ACTIVE WARRANT / HIT DETECTED</span>
                                                        <span style={{ marginLeft: 8 }} aria-hidden>⚠</span>
                                                    </div>
                                                </div>
                                            )} */}
                                            {/* NCIC / TCIC Query header */}
                                            <div
                                                className="row py-2 px-4 d-flex justify-content-between align-items-center mb-2"
                                                style={{
                                                    backgroundColor: '#001f3f',
                                                    color: '#fff',
                                                    borderBottom: '1px solid rgba(255,255,255,0.15)',
                                                }}
                                            >
                                                <div className="d-flex flex-column">
                                                    <p className="p-0 m-0 font-weight-bold" style={{ fontSize: 18, fontWeight: 600, letterSpacing: 0.5 }}>
                                                        NCIC / TCIC Query
                                                    </p>
                                                    <p className="p-0 m-0 mt-1" style={{ fontSize: 12, opacity: 0.9 }}>
                                                        {`${IncNo ? `Linked to Call ${IncNo} •` : ''} Operator #${localStoreData?.NCICLoginId} • ORI: ${localStoreData?.NCICORI}`}
                                                    </p>
                                                </div>
                                                <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
                                                    {/* <button
                                                        type="button"
                                                        className="btn btn-sm"
                                                        style={{ backgroundColor: '#495057', color: '#fff', border: 'none' }}
                                                        onClick={() => setIsCompact((c) => !c)}
                                                    >
                                                        Compact
                                                    </button> */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm"
                                                        style={{ backgroundColor: '#495057', color: '#fff', border: 'none' }}
                                                        onClick={() => setSoundOn((s) => !s)}
                                                    >
                                                        Sound: {soundOn ? 'ON' : 'OFF'}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm"
                                                        style={{ backgroundColor: '#fd7e14', color: '#fff', border: 'none' }}
                                                    >
                                                        NCIC Checked
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm"
                                                        style={{ backgroundColor: ncicOnline ? '#198754' : '#dc3545', color: '#fff', border: 'none' }}
                                                    >
                                                        {ncicOnline ? "NCIC Online" : "NCIC Offline"}
                                                    </button>
                                                    {/* <button
                                                        type="button"
                                                        className="btn btn-sm"
                                                        style={{ backgroundColor: '#495057', color: '#fff', border: 'none' }}
                                                        onClick={() => setNcicOnline((o) => !o)}
                                                    >
                                                        Toggle Connection
                                                    </button> */}
                                                </div>
                                            </div>
                                            {isHeader && (
                                                <div
                                                    className="row mb-2"
                                                    style={{
                                                        backgroundColor: '#fff9e6',
                                                        borderLeft: '4px solid #ffc107',
                                                        padding: '12px 16px',
                                                        margin: '0',
                                                    }}
                                                >
                                                    <div className="col-12 p-0 d-flex align-items-center justify-content-between">
                                                        <div className="d-flex align-items-center" style={{ flex: 1 }}>
                                                            <i
                                                                className="fa fa-exclamation-triangle"
                                                                style={{
                                                                    color: '#ffc107',
                                                                    fontSize: '20px',
                                                                    marginRight: '12px'
                                                                }}
                                                            ></i>
                                                            <span style={{ color: '#000', fontSize: '14px', fontWeight: '500' }}>
                                                            Attach any response to an existing Call or Incident as needed
                                                            </span>
                                                        </div>
                                                        <div className="d-flex" style={{ gap: '8px' }}>
                                                            <button
                                                                className="btn btn-sm btn-CADprimary"
                                                                type="button"
                                                                disabled={selectedNCICRows.length === 0 || !isCAD}
                                                                onClick={handleAttachToIncident}
                                                            >
                                                                Attach to Call
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-CADprimary"
                                                                type="button"
                                                                disabled={selectedNCICRows.length === 0 || isCAD}
                                                                onClick={handleAttachToIncident}
                                                            >
                                                                Attach to Incident
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="px-3">
                                                <Tab.Container activeKey={tabState}>
                                                    {viewMode !== 'response' && <NCICNav tabState={tabState} setTabState={handelChangeTab} isNameCallTaker={isNameCallTaker} />}
                                                    {viewMode === 'response' ? <ResponseSection ncicResponseData={ncicResponseData} loginAgencyID={loginAgencyID} tabState={tabState} setResponseSectionData={setResponseSectionData} /> :
                                                        <fieldset className="ncic-main-container">
                                                            <div className="d-flex justify-content-start align-items-start" style={{ gap: "16px" }}>
                                                                <div style={{ width: '50%' }}>
                                                                    {/* Left side: Tab Content */}
                                                                    <Tab.Content>
                                                                        {/* VIN Section */}
                                                                        <Tab.Pane eventKey="vin-container" unmountOnExit={false}>
                                                                            <VINSection
                                                                                vehicleSectionState={vehicleSectionState}
                                                                                setVehicleSectionState={setVehicleSectionState}
                                                                                handleVehicleSectionState={handleVehicleSectionState}
                                                                                clearVehicleSectionState={clearVehicleSectionState}
                                                                                suffixIdDrp={suffixIdDrp}
                                                                                stateList={stateList}
                                                                                errorVehicleSectionState={errorVehicleSectionState}
                                                                                handleErrorVehicleSectionState={handleErrorVehicleSectionState}
                                                                                clearErrorVehicleSectionState={clearErrorVehicleSectionState}
                                                                                plateTypeIdDrp={plateTypeIdDrp}
                                                                                makeIdDrp={makeIdDrp}
                                                                            />
                                                                        </Tab.Pane>

                                                                        {/* By Wanted */}
                                                                        <Tab.Pane eventKey="wantedCheck-container" unmountOnExit={false}>
                                                                            <WantedCheckSection wantedCheckSectionState={wantedCheckSectionState} setWantedCheckSectionState={setWantedCheckSectionState} handleWantedCheckSectionState={handleWantedCheckSectionState} clearWantedCheckSectionState={clearWantedCheckSectionState} />
                                                                        </Tab.Pane>

                                                                        {/* By Name */}
                                                                        <Tab.Pane eventKey="name-container" unmountOnExit={false}>
                                                                            <NameSection
                                                                                nameSectionState={nameSectionState}
                                                                                setNameSectionState={setNameSectionState}
                                                                                handleNameSectionState={handleNameSectionState}
                                                                                clearNameSectionState={clearNameSectionState}
                                                                                suffixIdDrp={suffixIdDrp}
                                                                                raceIdDrp={raceIdDrp}
                                                                                errorNameSectionState={errorNameSectionState}
                                                                                handleErrorNameSectionState={handleErrorNameSectionState}
                                                                            />
                                                                        </Tab.Pane>

                                                                        {/* By Wanted */}
                                                                        <Tab.Pane eventKey="wanted-container" unmountOnExit={false}>
                                                                            <WantedSection wantedSectionState={wantedSectionState} setWantedSectionState={setWantedSectionState} handleWantedSectionState={handleWantedSectionState} handleErrorWantedSectionState={handleErrorWantedSectionState} errorWantedSectionState={errorWantedSectionState} raceIdDrp={raceIdDrp} suffixIdDrp={suffixIdDrp}
                                                                            />
                                                                        </Tab.Pane>

                                                                        <Tab.Pane eventKey="driver-license" unmountOnExit={false}>
                                                                            <DriverLicenseSection
                                                                                driverLicenseSectionState={driverLicenseSectionState}
                                                                                setDriverLicenseSectionState={setDriverLicenseSectionState}
                                                                                handleDriverLicenseSectionState={handleDriverLicenseSectionState}
                                                                                suffixIdDrp={suffixIdDrp}
                                                                                raceIdDrp={raceIdDrp}
                                                                                stateList={stateList}
                                                                                errorDriverLicenseSectionState={errorDriverLicenseSectionState}
                                                                                handleErrorDriverLicenseSectionState={handleErrorDriverLicenseSectionState}
                                                                            />
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey="stolen-vehicle" unmountOnExit={false}>
                                                                            <StolenVehicleSection
                                                                                stolenVehicleSectionState={stolenVehicleSectionState}
                                                                                setStolenVehicleSectionState={setStolenVehicleSectionState}
                                                                                handleStolenVehicleSectionState={handleStolenVehicleSectionState}
                                                                                errorStolenVehicleSectionState={errorStolenVehicleSectionState}
                                                                                handleErrorStolenVehicleSectionState={handleErrorStolenVehicleSectionState}
                                                                                stateList={stateList}
                                                                            />
                                                                        </Tab.Pane>
                                                                    </Tab.Content>
                                                                </div>
                                                                {/* Right side */}
                                                                {
                                                                    viewMode === 'mix' && (
                                                                        <>
                                                                            {/* View Section */}
                                                                            {viewSummary &&
                                                                                <div className="d-felx flex-column" style={{ gap: '8px', width: "50%" }}>
                                                                                    {matchedNcicKeywords.length > 0 && (<div className="p-2 text-center mb-2 rounded" style={{ border: '1px solid red', backgroundColor: 'yellow' }}>

                                                                                        <span style={{ color: 'red', fontWeight: 600, fontSize: '20px' }}>
                                                                                            {matchedNcicKeywords.join(', ')}
                                                                                        </span>
                                                                                    </div>
                                                                                    )}

                                                                                    <div className="mb-2 border border-dark" style={{ maxHeight: "30vh", minHeight: "200px", overflowY: "auto", padding: "8px", backgroundColor: "#f8f9fa", }}>
                                                                                        <div style={{ fontSize: "13px" }}>
                                                                                            {summaryData && (
                                                                                                <div>
                                                                                                    {/* Display FormattedResponse if available */}
                                                                                                    {summaryData?.FormattedResponse && (
                                                                                                        <div dangerouslySetInnerHTML={{ __html: summaryData?.FormattedResponse }} />
                                                                                                    )}

                                                                                                    {/* Display VehicleResponse details if available */}
                                                                                                    {summaryData.NcicParseResponse?.VehicleResponse && (
                                                                                                        <div>
                                                                                                            <h6>Vehicle Details:</h6>
                                                                                                            <p><strong>License Plate:</strong> {summaryData?.VehicleResponse?.LicensePlateNumber}</p>
                                                                                                            <p><strong>State:</strong> {summaryData?.VehicleResponse?.LicensePlateState}</p>
                                                                                                            <p><strong>Make:</strong> {summaryData.NcicParseResponse.VehicleResponse.VehicleMake}</p>
                                                                                                            <p><strong>Model:</strong> {summaryData?.VehicleResponse?.VehModel}</p>
                                                                                                            <p><strong>Year:</strong> {summaryData?.VehicleResponse?.VehYear}</p>
                                                                                                            <p><strong>VIN:</strong> {summaryData.NcicParseResponse.VehicleResponse.VehicleIdNumber}</p>
                                                                                                            <p><strong>Owner:</strong> {summaryData?.VehicleResponse?.Name}</p>
                                                                                                            <p><strong>Address:</strong> {summaryData?.VehicleResponse?.Address}</p>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    )
                                                                }
                                                            </div>

                                                            {/* Table Section – full width below */}
                                                            {viewMode === 'mix' && (
                                                                <div className="mt-2 w-100">
                                                                    <div className="table-responsive">
                                                                        <DataTable
                                                                            dense
                                                                            columns={column}
                                                                            data={ncicResponseData}
                                                                            customStyles={tableCustomStyles}
                                                                            pagination
                                                                            responsive
                                                                            striped
                                                                            highlightOnHover
                                                                            fixedHeader
                                                                            selectableRowsHighlight
                                                                            noDataComponent={isNoData ? "There are no data to display" : 'There are no data to display'}
                                                                            fixedHeaderScrollHeight="190px"
                                                                            persistTableHead={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}

                                                        </fieldset>
                                                    }
                                                </Tab.Container>
                                            </div>
                                        </div>

                                        {/* Buttons */}
                                        <div className="row px-4 pb-2" style={{ margin: "0", padding: "0", flexShrink: "0" }}>
                                            <div className="col-12 p-0">
                                                <div className="d-flex justify-content-between tab-form-row-gap">
                                                    <div className="d-flex tab-form-row-gap">
                                                        {effectiveNcicScreenPermission?.[0]?.AddOK ? <button
                                                            type="button"
                                                            className="save-button"
                                                            onClick={() => handleSendClick()}
                                                            disabled={isDisableSendButton}
                                                        >
                                                            {isDisableSendButton ? "Sending..." : "Send"}
                                                        </button> : <></>}
                                                        <button
                                                            type="button"
                                                            className="cancel-button"
                                                            onClick={() => handleClearSearch()}

                                                        >
                                                            {"Clear"}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="save-button"
                                                        >
                                                            {"Name Export"}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="save-button  "
                                                        >
                                                            {"Vehicle Export"}
                                                        </button>
                                                    </div>
                                                    <div className="d-flex tab-form-row-gap justify-content-center">
                                                        <button
                                                            type="button"
                                                            className={viewMode === 'response' ? responseSectionData?.FormattedResponse?.search("<span style='color: red;") > 0 ? "error-button" : responseSectionData?.FormattedResponse?.search("<span style='color: blue;") > 0 ? "hitOrange-button" : "save-button"
                                                                : summaryData?.FormattedResponse?.search("<span style='color: red;") > 0 ? "error-button" : summaryData?.FormattedResponse?.search("<span style='color: blue;") > 0 ? "hitOrange-button" : "save-button"}
                                                        // className={clickedRow?.hit ? "error-button" : !clickedRow?.hit ? "hitGreen-button" : "save-button"}
                                                        >
                                                            {"HIT YQ/YR"}
                                                        </button>
                                                    </div>
                                                    <div className="d-flex tab-form-row-gap justify-content-end">
                                                        <button
                                                            type="button"
                                                            className="save-button"
                                                            onClick={handleRequestClick} // Show only left section
                                                        >
                                                            {"Request"}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="save-button"
                                                            onClick={handleMixClick} // Show both left and right sections
                                                        >
                                                            {"Mix"}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="save-button"
                                                            onClick={() => {
                                                                handleResponseClick();
                                                            }}
                                                        >
                                                            {"Response"}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            data-dismiss="modal"
                                                            className="cancel-button"
                                                            onClick={() => {
                                                                onCloseNCICModal();
                                                            }}
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </dialog>
                    </>
                ) : (
                    <> </>
                )
                }

                {/* Incident Search Modal */}
                {showIncidentSearchModal && (
                    <div
                        className="modal show"
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                        onClick={(e) => {
                            if (e.target === e.currentTarget) {
                                setShowIncidentSearchModal(false);
                                setIncidentSearchData([]);
                                setSelectedIncident(null);
                                setIncidentReportedDate(null);
                                setIncidentReportedDateTo(null);
                            }
                        }}
                    >
                        <div className="modal-dialog modal-dialog-centered modal-xl" style={{ marginTop: '50px' }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Search Incident</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={() => {
                                            setShowIncidentSearchModal(false);
                                            setIncidentSearchData([]);
                                            setIncidentReportedDate(null);
                                            setIncidentReportedDateTo(null);
                                        }}
                                    >
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="d-flex flex-wrap align-items-end mb-3" style={{ gap: '10px' }}>
                                        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                            <label className="form-label mb-0 small text-nowrap">Reported Date From</label>
                                            <DatePicker
                                                id="incidentReportedDate"
                                                selected={incidentReportedDate}
                                                onChange={(date) => {
                                                    setIncidentReportedDate(date);
                                                    if (incidentReportedDateTo && date && date > incidentReportedDateTo) {
                                                        setIncidentReportedDateTo(null);
                                                    }
                                                }}
                                                dateFormat="MM/dd/yyyy"
                                                maxDate={new Date()}
                                                className="form-control"
                                                isClearable
                                                placeholderText="Select date"
                                                showMonthDropdown
                                                showYearDropdown
                                            />
                                        </div>
                                        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                            <label className="form-label mb-0 small text-nowrap">Reported Date To</label>
                                            <DatePicker
                                                id="incidentReportedDateTo"
                                                selected={incidentReportedDateTo}
                                                onChange={(date) => setIncidentReportedDateTo(date)}
                                                dateFormat="MM/dd/yyyy"
                                                minDate={incidentReportedDate || undefined}
                                                maxDate={new Date()}
                                                className="form-control"
                                                isClearable
                                                placeholderText="Select date"
                                                showMonthDropdown
                                                showYearDropdown
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            className="save-button"
                                            onClick={runIncidentSearch}
                                            disabled={loadingIncidentSearch}
                                        >
                                            Search
                                        </button>
                                    </div>
                                    {loadingIncidentSearch ? (
                                        <div className="text-center p-4">
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <DataTable
                                            columns={[
                                                {
                                                    name: '',
                                                    cell: (row) => (
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedIncident?.IncidentID === row.IncidentID}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setSelectedIncident(row);
                                                                } else {
                                                                    setSelectedIncident(null);
                                                                }
                                                            }}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    ),
                                                    sortable: false,
                                                    width: '50px',
                                                    center: true,
                                                },
                                                {
                                                    name: isCAD ? 'CAD Event #' : 'Incident #',
                                                    selector: (row) => isCAD ? row?.CADIncidentNumber : row.IncidentNumber || '',
                                                    sortable: true,
                                                    width: '150px',
                                                },
                                                {
                                                    name: 'Reported Date/Time',
                                                    selector: (row) => row.ReportedDate ? getShowingDateText(row.ReportedDate) : '',
                                                    sortable: true,
                                                    width: '180px',
                                                },
                                                {
                                                    name: 'Location',
                                                    selector: (row) => row.CrimeLocation || '',
                                                    sortable: true,
                                                },
                                            ]}
                                            data={incidentSearchData}
                                            customStyles={tableCustomStyles}
                                            pagination
                                            dense
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                            highlightOnHover
                                            pointerOnHover
                                            noDataComponent="No incidents found"
                                        />
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="save-button"
                                        onClick={handleSaveIncident}
                                        disabled={!selectedIncident}
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        className="cancel-button"
                                        onClick={() => {
                                            setShowIncidentSearchModal(false);
                                            setIncidentSearchData([]);
                                            setSelectedIncident(null);
                                            setIncidentReportedDate(null);
                                            setIncidentReportedDateTo(null);
                                        }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div >
        </>
    );
};

// PropTypes definition
NCICModal.propTypes = {
    openNCICModal: PropTypes.bool.isRequired,
    setOpenNCICModal: PropTypes.func.isRequired,
    isNameCallTaker: PropTypes.bool,
    setIsNameCallTaker: PropTypes.func,
    NameID: PropTypes.number,
    PropertyID: PropTypes.number,
    VehicleID: PropTypes.number,
    incidentData: PropTypes.object,
    IncidentID: PropTypes.number,
    IncNo: PropTypes.number,
};

export default memo(NCICModal);
